<template>
  <fade-transition>
    <b-alert
      v-model="visible"
      :variant="type"
      :class="[{ 'alert-dismissible': dismissible }]"
      role="alert"
    >
      <div v-if="type=='danger'">{{ $t('alert.title') }}</div>
      <slot v-if="!dismissible"></slot>
      <template v-else>
        <span class="alert-text">
          <slot></slot>
        </span>
        <slot name="dismiss-icon">
          <button type="button"
                  class="close"
                  data-dismiss="alert"
                  aria-label="Close"
                  @click="dismissAlert">
            <span aria-hidden="true">×</span>
          </button>
        </slot>
      </template>
    </b-alert>
  </fade-transition>
</template>
<script>
  import { FadeTransition } from 'vue2-transitions';

  export default {
    name: 'base-alert',
    components: {
      FadeTransition
    },
    props: {
      type: {
        type: String,
        default: 'default',
        description: 'Alert type'
      },
      dismissible: {
        type: Boolean,
        default: false,
        description: 'Whether alert is dismissible (closeable)'
      },
      visible: {
        type: Boolean,
        default: false,
        description: 'Show alert if true'
      }      
    },
    data() {
      return {
        
      };
    },
    methods: {     
      dismissAlert() {
        this.visible = false;
      }
    }
  };
</script>
